export default {
  'app.setting.pagestyle': 'ページスタイル設定',
  'app.setting.pagestyle.dark': 'ダークスタイル',
  'app.setting.pagestyle.light': 'ライトスタイル',
  'app.setting.content-width': 'コンテンツ幅',
  'app.setting.content-width.fixed': '固定',
  'app.setting.content-width.fluid': '流動',
  'app.setting.themecolor': 'テーマカラー',
  'app.setting.themecolor.dust': 'ダストレッド',
  'app.setting.themecolor.volcano': 'ボルケーノ',
  'app.setting.themecolor.sunset': 'サンセットオレンジ',
  'app.setting.themecolor.cyan': 'シアン',
  'app.setting.themecolor.green': 'ポーラーグリーン',
  'app.setting.themecolor.daybreak': 'デイブレイクブルー（デフォルト）',
  'app.setting.themecolor.geekblue': 'ギークブルー',
  'app.setting.themecolor.purple': 'ゴールデンパープル',
  'app.setting.navigationmode': 'ナビゲーションモード',
  'app.setting.sidemenu': 'サイドメニューレイアウト',
  'app.setting.topmenu': 'トップメニューレイアウト',
  'app.setting.fixedheader': '固定ヘッダー',
  'app.setting.fixedsidebar': '固定サイドバー',
  'app.setting.fixedsidebar.hint': 'サイドメニューレイアウトで動作',
  'app.setting.hideheader': 'スクロール時にヘッダーを非表示',
  'app.setting.hideheader.hint': 'ヘッダー非表示が有効時に動作',
  'app.setting.othersettings': 'その他の設定',
  'app.setting.weakmode': '色覚障がい者向けモード',
  'app.setting.copy': '設定をコピー',
  'app.setting.copyinfo':
    'コピー成功、src/models/setting.jsのdefaultSettingsを置き換えてください',
  'app.setting.production.hint':
    '設定パネルは開発環境でのみ表示されます。手動で変更してください',
};